module.exports = __webpack_public_path__ + "static/sanderdoorn_2-1a2edfcccb399fdea717f305b527b9c1.jpg";